import './Toast.css';

const ICONS = {
  success: '✓',
  error: '✕',
  info: 'ℹ',
};

export function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div className={`toast toast--${toast.type}`} role="status" aria-live="polite">
      <span className="toast__icon">{ICONS[toast.type] ?? ICONS.info}</span>
      <span className="toast__message">{toast.message}</span>
    </div>
  );
}
